import React from "react";
import Page from "../_Layouts/MainExternal";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import FormClassic from "customHooks/useCompleoReactHookForm/components/FormClassic";
import useCompleoReactHookForm from "customHooks/useCompleoReactHookForm";
import useGetMetadata from "customHooks/useGetMetadata";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import stylesForm from "Pages/_Layouts/generalForm";
import { ApiStateType, useApi, useApiCache } from "customHooks/useApi";
import useValuesFromSource from "customHooks/useValuesFromSource";
import { RouteComponentProps } from "@gatsbyjs/reach-router";
import { Alert } from "@material-ui/lab";
import { Box } from "@material-ui/core";
import TermsOfUseAndPrivacyFooter from "Components/TermsOfUseAndPrivacyFooter";
import useExternalHelper from "customHooks/useExternalHelper";

const useStyles = makeStyles((theme: Theme) => createStyles(stylesForm));

interface IProps extends RouteComponentProps {
    uuid?: string;
}

const CustomComponents = [
    {
        name: "footer",
        component: TermsOfUseAndPrivacyFooter
    }
];

const JobApprovalUser = (props: IProps) => {
    const postAddressSearch = `/jobapprovalworkflow/get-job-approval-user-external`;
    const runApiCall = props.uuid !== "finished";
    const [getListResult] = useApiCache(
        postAddressSearch,
        "post",
        { uuid: props.uuid },
        !runApiCall
    );
    const [t, i18n, readyTranslation] = useTranslation("JOBAPPROVALUSER", {
        useSuspense: false
    });
    const expired = getListResult?.response?.data?.expired === true;
    const notFound = getListResult?.response?.data?.notFound === true;
    const userFinished = getListResult?.response?.data?.finished === true;
    const notAvailable = getListResult?.response?.data?.notAvailable === true;
    const finishedRedirect = props.uuid === "finished";
    const nodata = expired || notFound || userFinished || notAvailable;
    const externalCompanyId = getListResult?.response?.data?.data?.companyId;
    useExternalHelper(externalCompanyId);

    const [metadata] = useGetMetadata("JOBAPPROVALUSER");
    const [valuesFromSource] = useValuesFromSource(
        metadata,
        false,
        {},
        !nodata ? getListResult : undefined,
        !nodata ? ["data", "data"] : undefined
    );

    valuesFromSource.uuid = props.uuid;
    valuesFromSource.jobTitle = `${valuesFromSource.jobTitle} (${getListResult?.response?.data?.data?.jobId})`;
    const postAddress = `/jobapprovalworkflow/save-job-approval-user-external`;

    const [addBranchReturn, addBranch] = useApi(postAddress, "post");

    const [formCompleo, finished] = useCompleoReactHookForm({
        FormType: FormClassic,
        i18nV: i18n,
        metadadosRetorno: metadata,
        postMethod: addBranch,
        postReturn: addBranchReturn,
        ready: readyTranslation,
        valuesFromSource: valuesFromSource,
        t: t,
        redirectAddress: "/jobapprovaluser/finished",
        CustomComponents: CustomComponents
    });
    const { showMessage, messageId, severity } = getMessage({
        expired: expired,
        notFound: notFound,
        userFinished: userFinished,
        finishedRedirect: finishedRedirect,
        notAvailable: notAvailable
    });
    if (!readyTranslation || !finished) {
        return <Loading />;
    }
    if (showMessage) {
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="lg"
            >
                <Alert style={{ width: "100%" }} severity={severity}>
                    {t(messageId)}
                </Alert>
            </Page>
        );
    }

    return (
        <Page
            featureName={t("a_FeatureName")}
            featureMainDescription={t("a_FeatureMainDescription")}
            maxWidth="lg"
        >
            {formCompleo}
        </Page>
    );
};

function getMessage(params: {
    expired: boolean;
    notFound: boolean;
    userFinished: boolean;
    finishedRedirect: boolean;
    notAvailable: boolean;
}) {
    let messageId = "";
    let severity: "error" | "warning" | "success" = "success";
    if (params.expired) {
        messageId = "messageExpired";
        severity = "warning";
    } else if (params.notFound) {
        messageId = "messageNotFound";
        severity = "error";
    } else if (params.finishedRedirect) {
        messageId = "messageSuccess";
        severity = "success";
    } else if (params.userFinished) {
        messageId = "alreadySubmitted";
        severity = "warning";
    } else if (params.notAvailable) {
        messageId = "notAvailable";
        severity = "error";
    }
    const showMessage =
        params.expired ||
        params.notFound ||
        params.userFinished ||
        params.finishedRedirect ||
        params.notAvailable;
    return {
        showMessage,
        messageId,
        severity
    };
}

export default JobApprovalUser;
